import {RootState} from 'redux/store';

export const getBaitBoxLogsDetails = (state: RootState) => state.baitBoxLogDetails.data;
